<template>
  <div class="dr__maintenance">
    <!-- 是否显示下线 -->
    <div :class="{ 'info-box': border }">
      <ul class="base-info">
        <li v-for="(item, index) of infoList" :key="index" class="info-item">
          <div class="info_label">
            <split-label class-name="label" :label="$t(item.title)" />
          </div>
          <div class="info_value">
            <p>{{ item.content }}</p>
          </div>
        </li>
      </ul>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'DrMaintenance',
  props: {
    infoList: {
      type: Array,
      default: () => ([])
    },
    border: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
  .dr__maintenance {
    background: #ffffff;
    border-radius: 5px;
    .info-box {
      border-bottom: 1px solid #f2f2f2;
    }
    /* 方便外部使用 */
    .base-info {
      padding: 18px 16px;
      .info-item {
        display: flex;
        align-items: center;
        margin-bottom: 17.5px;
        &:last-child {
          margin-bottom: 0;
        }
        .info_label {
          width: 59.5px;
          line-height: 13.5px;
          .label {
            span {
              font-size: 14px;
              line-height: 13.5px;
            }
          }
        }
        .info_value {
          flex: 1;
          margin-left: 24.5px;
          font-size: 14px;
          word-break: break-all;
          line-height: 13.5px;
          p {
            font-size: 14px;
            line-height: 14px;
            color: #808C9B;
          }
        }
      }
    }
  }
</style>
